import {Editor, EditorContent} from '@tiptap/react';
import React, {FC} from 'react';
import styled from 'styled-components';

import {LinkTrap} from '../../../../../../src/components/common/linkTrap/linkTrap';
import {LinkTooltips} from '../../../../../../src/components/common/tooltips/linkTooltips';
import {
  growToFitHeightContainerStyle,
  growToFitHeightStyle,
} from '../../../../../shared/ui/src/styles/styleHelpers';

/*
 * Props.
 */

interface ArticleEditorProps {
  editor: Editor;
}

/*
 * Style.
 */

const StyledEditorWrapperDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: inherit;
  border: 1px solid ${(p) => p.theme.greys.shade30};
  border-bottom: 0px;
  box-shadow: 0px 1px 9px ${(p) => p.theme.greys.shade30};
  border-radius: 16px 16px 0px 0px;
  height: 100%;
`;

const StyledEditorContent = styled(EditorContent)`
  padding: 5px 5px 0px 24px;
  .kb-blockquote {
    border-left: 3px solid ${(p) => p.theme.greys.shade40};
    padding-left: 1rem;
  }
  .kb-link {
    color: ${(p) => p.theme.palette.blue.shade40};
  }
`;

const StyledLinkTooltips = styled(LinkTooltips)`
  ${growToFitHeightContainerStyle};
`;

const StyledLinkTrap = styled(LinkTrap)`
  ${growToFitHeightStyle};
  ${growToFitHeightContainerStyle};
`;

/*
 * Component.
 */

export const ArticleEditor: FC<ArticleEditorProps> = ({editor}) => (
  <StyledEditorWrapperDiv>
    <StyledLinkTooltips showKeyboardShortcut>
      <StyledLinkTrap requireMetaKey>
        <StyledEditorContent editor={editor} />
      </StyledLinkTrap>
    </StyledLinkTooltips>
  </StyledEditorWrapperDiv>
);
